import { Pipe, PipeTransform } from '@angular/core';
import { CountryZone } from 'app/modules/admin/apps/country-zone/country-zone.types';

@Pipe({
  name: 'GetCountryNameByCode',
})
export class GetCountryNameByCodePipe implements PipeTransform {
  transform(countryCode: string, countryList: CountryZone[]): unknown {
    return (
      countryList.find((cz) => cz.countryZoneCode === countryCode)?.name ||
      'None'
    );
  }
}
